module.exports = __webpack_public_path__ + "static/img/JM@3x.85159a30.jpg";